import { Loan } from './Loan';

export default Loan;
